import { http } from "./config";

export default {
  listar: (data) => {
    // const queryParams = `
    // id=${data.id ? data.id : ""}
    // &cliente=${data.cliente ? data.cliente : ""}
    // &status=${data.status ? data.status : ""}
    // &data=${data.data ? data.data : ""}
    // &estadoNfe=${data.estadoNfe ? data.estadoNfe : ""}
    // &numeroNfe=${data.numeroNfe ? data.numeroNfe : ""}
    // &estadoNfce=${data.estadoNfce ? data.estadoNfce : ""}
    // &numeroNfce=${data.numeroNfce ? data.numeroNfce : ""}
    // &limit=${data.limit ? data.limit : ""}
    // &page=${data.page ? data.page : 1}
    // &excluidas=${data.excluidas ? data.excluidas : false}
    // &content=${data.content ? data.content : 'json'}
    // &periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ""}
    // &periodo_final=${data.periodo_final ? data.periodo_final : ""}
    // &formaPagamentoId=${data.formaPagamentoId ? data.formaPagamentoId : ""}
    // `
    return http.get(`/v1/vendas`, {params: data});
  },
  listarPorPeriodo: (data) => {
    // const queryParams = `
    //         periodo_inicial=${data.periodo_inicial ? data.periodo_inicial : ""}
    //         &periodo_final=${data.periodo_final ? data.periodo_final : ""}
    //         &formaPagamentoId=${data.formaPagamentoId ? data.formaPagamentoId : ""}
    //         &content=${data.content ? data.content : ""}
    //         `;

    return http.get(`/v1/vendas`, {params: data});
  },
  salvar: (data) => {
    return http.post("/v1/vendas", data);
  },
  editar: (id) => {
    return http.get(`/v1/vendas/${id}`);
  },
  atualizar: (data) => {
    return http.put(`/v1/vendas/${data.id}`, data);
  },
  excluir: (data) => {
    return http.delete(`/v1/vendas/${data.id}?motivo_exclusao=${data.motivo_exclusao}`);
  },
  imprimirCupomNaoFiscal: (id) => {
    return http.get(`/v1/venda/${id}/imprimir/cupom-nao-fiscal`);
  },
  imprimirChecklistProdutos: (id) => {
    return http.post(`/v1/venda/imprimir-checklist-produtos`, {venda_id:  id})
  }
};

